import React from "react"
import { useField } from "formik"
import PhoneInput from "react-phone-number-input"
import "react-phone-number-input/style.css"

type Props = {
  name: string
  label: string
  placeholder?: string
}

// Formik-bound version of the country-code phone input used everywhere a wealth
// manager captures a cellphone number (see shared/PhoneInput, ClientForm). Keeps
// the invite form on the same control — flag picker, +27 prefix, E.164 value —
// instead of a bare text field.
export const PhoneFieldWithLabel: React.FC<Props> = ({
  name,
  label,
  placeholder = "Enter cellphone number",
}) => {
  const [field, meta, helpers] = useField<string>(name)
  const showError = Boolean(meta.touched && meta.error)

  return (
    <div className={`form-field app-form__field${showError ? " has-error" : ""}`}>
      <label htmlFor={name}>{label}</label>
      <PhoneInput
        id={name}
        name={name}
        placeholder={placeholder}
        defaultCountry="ZA"
        value={field.value || undefined}
        // The picker emits undefined once the field is cleared; Yup needs "".
        onChange={(value) => helpers.setValue(value ?? "")}
        onBlur={() => helpers.setTouched(true)}
      />
      {showError && <span>{meta.error}</span>}
    </div>
  )
}
